<script>

</script>

<div class="card">
  <slot></slot>
</div>

<style>
    .card
    {
        border: 1px solid lightcyan;
        background-color: #fff;
        border-radius: 6px;
        box-shadow: 0px 2px 4px rgba(0,0,0,0.1);
        cursor: pointer;
    }
    
</style>